import { DesignSystem } from '@/src/design-system'

export function StateCallPromoCardSkeleton() {
  return (
    <DesignSystem.Skeleton.Skeleton
      style={{ width: '100%', height: 420, overflow: 'hidden', borderRadius: 16 }}
    />
  )
}
